import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { JWT, ROUTES } from "../config/constants";

/**
 * AdminRoute Component
 * Protects routes that require admin access
 * Redirects non-admin users to home page
 */
function AdminRoute({ children }) {
  const token = localStorage.getItem(JWT.TOKEN_KEY);

  if (!token) {
    // No token, redirect to login
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const isAdmin = decoded.is_admin === true || decoded.isAdmin === true;

    if (!isAdmin) {
      // User is logged in but not admin, redirect to home
      return <Navigate to={ROUTES.HOME} replace />;
    }

    // User is admin, render the protected component
    return children;
  } catch (error) {
    // Invalid token, redirect to login
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
}

export default AdminRoute;
